import React from 'react'
import DynamicTable from '../../CommonUtils/DynamicTable'

const MessageA13t = (probs) => {
    const data = probs?.item?.text_data?.data[0]
  return (
    <div>
   
      <DynamicTable data = {data?.name}{...probs}/>
    </div>
  )
}

export default MessageA13t
